import { useEffect, useRef } from "react"

/**
 * Scrolls the returned ref's element into view when editing starts. The Edit
 * button sits in the panel header while the Fields section it opens can be far
 * below the fold (behind active work and long sub-tables), so without this a
 * click looks like it did nothing.
 */
export function useScrollIntoViewOnEdit<T extends HTMLElement>(
  editing: boolean,
) {
  const ref = useRef<T>(null)

  useEffect(() => {
    if (editing) {
      ref.current?.scrollIntoView?.({ behavior: "smooth", block: "start" })
    }
  }, [editing])

  return ref
}
